// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__ZfDuO","selfFetch":"Terms_selfFetch__MZTdK"};